import script from "./liveVideoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./liveVideoModal.vue?vue&type=script&setup=true&lang=js"

import "./liveVideoModal.vue?vue&type=style&index=0&id=646bdc2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-646bdc2c"]])

export default __exports__